import { recordFromSnapshot } from 'utils/firebaseUtils'
import Api from 'dashpoolApi'
import moment from 'moment'
import { MODAL_CLIENT_SELECT_USER, hideModal } from './modals'

// import moment from 'moment'
// ------------------------------------
// Constants
// ------------------------------------
export const CREATE_USER_ERROR = 'CREATE_USER_ERROR'
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS'
export const DELETE_USER_ERROR = 'DELETE_USER_ERROR'
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS'
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const NEW_USER = 'NEW USER'
export const SELECT_USER = 'SELECT_USER'
export const AUTH_SELECT_USER_SUCCESS = 'AUTH_SELECT_USER_SUCCESS'

// ------------------------------------
// Logic Actions
// ------------------------------------
export function selectUser(user) {
  return (dispatch, getState) => {
    const expiresAt = moment()
    expiresAt.add(30, 'm')
    user.expiresAt = expiresAt.format()
    user.auth = false
    const api = new Api(dispatch, getState)
    return api
      .post('hiboutik/credentials', {
        hbKey: user.key,
        hash: user.passwordHash
      })
      .then(res => {
        user.pwdHash = res.data.hash
        return dispatch({
          type: SELECT_USER,
          payload: user
        })
      })
      .then(() => {
        return dispatch(hideModal(MODAL_CLIENT_SELECT_USER))
      })
  }
}
export function authHbUserDone() {
  return (dispatch, getState) => {
    dispatch({ type: AUTH_SELECT_USER_SUCCESS })
  }
}
export function refreshUsers() {
  return (dispatch, getState) => {
    const api = new Api(dispatch, getState)
    api.get('/refresh/users').catch(err => {
      console.error(err)
    })
  }
}
export function completeUser(user, changes) {
  return (dispatch, getState) => {
    dispatch(updateUser(user, changes))
  }
}
// ------------------------------------
// Basic Actions
// ------------------------------------
function createUser(user) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    user.show = false
    firebase.child('users').push(user, error => {
      if (error) {
        console.error('ERROR @ createUSER :', error)
        dispatch({
          type: CREATE_USER_ERROR,
          payload: error
        })
      }
    })
  }
}

export function deleteUser(user) {
  return (dispatch, getState) => {
    const { firebase } = getState()

    firebase.child(`users/${user.key}`).remove(error => {
      if (error) {
        console.error('ERROR @ deleteUser :', error)
        dispatch({
          type: DELETE_USER_ERROR,
          payload: error
        })
      }
    })
  }
}

export function updateUser(user, changes) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    firebase.child('hbUsers/' + user.key).update(changes, error => {
      if (error) {
        console.error('ERROR @ updateUser :', error)
        dispatch({
          type: UPDATE_USER_ERROR,
          payload: error
        })
      }
    })
  }
}

export function registerUsersListeners() {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const ref = firebase.child('hbUsers')
    ref.on('child_added', snapshot => {
      const user = recordFromSnapshot(snapshot)
      dispatch({
        type: CREATE_USER_SUCCESS,
        payload: user
      })
    })

    ref.on('child_changed', snapshot => {
      const user = recordFromSnapshot(snapshot)
      const { currentUser } = getState().users
      dispatch({
        type: UPDATE_USER_SUCCESS,
        payload: user
      })
      if (currentUser && user.key === currentUser.key) {
        return dispatch({
          type: SELECT_USER,
          payload: user
        })
      }
    })

    ref.on('child_removed', snapshot =>
      dispatch({
        type: DELETE_USER_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    )
  }
}

export const actions = {
  createUser,
  updateUser,
  registerUsersListeners
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CREATE_USER_SUCCESS]: (state, action) => {
    let list
    list = [...state.list, action.payload]
    return Object.assign({}, state, { list: list })
  },
  [CREATE_USER_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [UPDATE_USER_SUCCESS]: (state, action) => {
    return Object.assign({}, state, {
      list: state.list.map(user => {
        return user.key === action.payload.key ? action.payload : user
      })
    })
  },
  [UPDATE_USER_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [DELETE_USER_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      list: state.list.filter(user => {
        return user.key !== action.payload.key
      })
    }),
  [DELETE_USER_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [SELECT_USER]: (state, action) =>
    Object.assign({}, state, { currentUser: action.payload }),
  [AUTH_SELECT_USER_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      currentUser: { ...state.currentUser, auth: true }
    }),
  [NEW_USER]: (state, action) => Object.assign({}, state)
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = { list: [], currentUser: null }
export default function usersReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/redux/modules/user.js